import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle,
    //------------- globalStates
    globalStates,
    //------------- defalutData
    defaultData, 
    //------------- Helpers
    Helpers,
    //------------- Forms
    Forms,
    //------------- FetchData
    FetchData
}) =>{

    // Para redirigir a otras pantallas
    const navigate = useNavigate();

    // ------------------------------------ DEMO MODAL
    const abrirModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }
    
    const cerrarModal = () => {
        toggle()
    }

    const handleClickDemoModal = async (_, title, compont, dataRequest) => {
        abrirModal(_, title, compont, dataRequest)
    }

    // ------------------------------------ DEMO MODAL

    const handleClickShowForm = (flag) => {
        const { setShowForm } = globalStates
        setShowForm(flag)
    }

    // Cancela la visualizacion del formulario al darle click al botón "Cancelar"
    const handleClickHideForm = () => {

        const { setStepApplilication } = globalStates
        const { FormScreen } = Forms
        const { onResetForm } = FormScreen

        onResetForm()
        setStepApplilication(0)
        handleClickShowForm(false)

    }

    const handleClickReturnStep = () => {
        const { stepApplilication, setStepApplilication} = globalStates
        setStepApplilication(stepApplilication-1)
    }

    const handleClickNextStep = () => {
        const { stepApplilication, setStepApplilication} = globalStates
        setStepApplilication(stepApplilication+1)
    }

    const handleClickFetchAllManagements = async () => {

        const { fetchAllManagements } = FetchData
        const { executeFetch } = fetchAllManagements

        executeFetch()

    }

    const handleClickFetchSpecificManagement = async (idgestion, estado) => {
        
        const { FormScreen: {onResetForm} } = Forms
        const { setFormOpeningMode } = globalStates
        const { fetchSpecificManagement } = FetchData

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        fetchSpecificManagement.setParamsToSearch({
            idgestion: idgestion
        })
        fetchSpecificManagement.executeFetch()

        const openMode = estado 
            ? 'EDITABLE'
            : 'READONLY'
        setFormOpeningMode(openMode)

        handleClickShowForm(true)

    }

    const handleClickEnableDisableManagement = async (idgestion, estado) => {
        console.log('handleClickEnableDisableManagement', {idgestion, estado})
        Swal.fire({
            title: '¿Está seguro de cambiar el estado de este registro?',
            text: 'Esta acción hará que el registro vuelva a mostrarse en los listados que se encuentran en todo el sistema y podrá asociar información a él nuevamente',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Continuar',
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.post(`/general-managements/enable-disable-management`, {idgestion, estado})
                    .then(({ data }) => {
                        
                        alertMessage(data)
                        handleClickFetchAllManagements()

                    })
                    .catch(error => {
                        console.log('API ERROR: ', error)
                    })
            }
        })
    }

    // const handleClickDeleteManagement = async (idgestion) => {

    //     Swal.fire({
    //         title: '¿Está seguro de eliminar este registro?',
    //         text: 'Esta acción no se puede deshacer, haga click en "Eliminar" para continuar',
    //         icon: 'warning',
    //         showCancelButton: true,
    //         confirmButtonColor: '#ff6219',
    //         cancelButtonText: 'Cancelar',
    //         confirmButtonText: 'Eliminar',
    //     }).then(async result => {
    //         if (result.isConfirmed) {
    //             await marvarApi.delete(`/general-managements/delete-management/${idgestion}`)
    //             .then(({ data }) => {
                    
    //                 alertMessage(data)
    //                 handleClickFetchAllManagements()

    //             })
    //             .catch(error => {
    //                 console.log('API ERROR: ', error)
    //             })
    //         }
    //     })
        
    // }

    const handleClickResetLogForm = async () => {

        const { LogsForm } = Forms
        const { setFormState } = LogsForm

        setFormState(prevState => ({
            ...prevState,
            // gestion_fecha: '',
            descripcion: ''
        }))
        
    }

    const handleClickContinue = async () => {
        const { fetchAllLogs } = FetchData
        const { FormScreen, LogsForm } = Forms

        LogsForm.formState.idgestion = FormScreen.formState.idgestion
        fetchAllLogs.setParamsToSearch({
            idgestion: FormScreen.formState.idgestion
        })
        fetchAllLogs.executeFetch()

        handleClickNextStep()
    }
    
    const onSubmitForm = async (e) => {

        e.preventDefault()

        const { setLoadingSubmitForm } = Helpers
        const { fetchAllLogs } = FetchData
        const { FormScreen, LogsForm } = Forms
        const { formState, onResetForm } = FormScreen

        if ( formState.titulo === '' || formState.descripcion === '' ){
            const messageCustom = {
                message: 'Debe completar todos los campos del formulario',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom) 
            return
        }

        const _dataBody = {
            idgestion: formState.idgestion,
            fecha: formState.fecha,
            titulo: formState.titulo,
            descripcion: formState.descripcion,
            user: user.username
        }

        console.log('[useActions][onSubmitForm] _dataBody ', _dataBody)
        // setLoadingSubmitForm(true)
        await marvarApi.post( `/general-managements/create-management`, _dataBody )
            .then(({ data }) => {

                console.log('data ::: ', data)
                
                alertMessage(data)
                const idgestion = formState.idgestion === '' 
                    ? data.rows[0].insertId
                    : formState.idgestion
                formState.idgestion = idgestion
                LogsForm.formState.idgestion = idgestion
                
                handleClickFetchAllManagements()
                fetchAllLogs.setParamsToSearch({idgestion: formState.idgestion})
                fetchAllLogs.executeFetch()
                
                handleClickNextStep()
                // setLoadingSubmitForm(false)

            })
            .catch(error => {
                console.log('API ERROR: ', error)
                // setLoadingSubmitForm(false)
            })
    }

    const onSubmitLog = async (e) => {

        e.preventDefault()

        const { fetchAllLogs } = FetchData
        const { LogsForm } = Forms
        const { formState } = LogsForm

        const _dataBody = {
            idgestion: formState.idgestion,
            descripcion: formState.descripcion,
            user: user.username
        }

        console.log('[useActions][onSubmitLog] _dataBody ', _dataBody)

        await marvarApi.post(`/general-managements/create-log`, _dataBody )
            .then(({ data }) => {
                alertMessage(data)
                if (data.flag === 'OK') {
                    fetchAllLogs.setParamsToSearch({
                        idgestion: formState.idgestion
                    })
                    fetchAllLogs.executeFetch()
                    handleClickResetLogForm()
                }
            })
            .catch(error => {
                console.log('API ERROR: ', error)
            })
    }

    return Object.freeze({
        abrirModal,
        cerrarModal,
        handleClickDemoModal,
        handleClickNextStep,
        handleClickReturnStep,
        
        handleClickShowForm,
        handleClickHideForm,
        handleClickFetchAllManagements,
        handleClickFetchSpecificManagement,
        handleClickEnableDisableManagement,
        // handleClickDeleteManagement,
        handleClickResetLogForm,
        handleClickContinue,
        onSubmitForm,
        onSubmitLog
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {

    if (res) {
        const { flag, message } = res
        if (flag === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}